import { render, staticRenderFns } from "./DevicesCardDeviceTabbedForm.vue?vue&type=template&id=5bfeb4d0&scoped=true&"
import script from "./DevicesCardDeviceTabbedForm.vue?vue&type=script&lang=ts&"
export * from "./DevicesCardDeviceTabbedForm.vue?vue&type=script&lang=ts&"
import style0 from "./DevicesCardDeviceTabbedForm.vue?vue&type=style&index=0&id=5bfeb4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfeb4d0",
  null
  
)

export default component.exports